// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"56512880","329":"776ab84c","446":"82c3961d","460":"84362f36","488":"22b449f6","551":"31fb7215","728":"5511dd40","730":"11ca7784","880":"19c72ae7","913":"8a18554b","969":"6c7242f3","979":"760ee662"}[chunkId] + ".chunk.js";
};